<template>
    <v-container fluid>
        <!-- GrowthTask Dialog -->
        <v-dialog v-model="growthTaskDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeGrowthTaskDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title
                        >Growth Task ID{{
                            selectedGrowthTaskRawId
                        }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToGrowthTaskDetail(selectedGrowthTaskNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <GrowthTaskDetailComponent
                        v-if="selectedGrowthTaskNodeId"
                        :growthTaskNodeId="selectedGrowthTaskNodeId"
                    ></GrowthTaskDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" width="1200" persistent scrollable>
            <v-card elevation-1>
                <v-card-title class="primary white--text">
                    <span v-if="plantGrowthTemplateObj">
                        {{ plantGrowthTemplateObj.name }}
                        <v-chip outlined dark class="mr-3"
                            >{{
                                plantGrowthTemplateObj.potSize.potSizeCm
                            }}
                            cm</v-chip
                        >
                        Growth Days:
                        {{ plantGrowthTemplateObj.totalGrowthDays }} / Sales
                        Days: {{ plantGrowthTemplateObj.maxSalesDays }}
                    </span>
                    <v-spacer />
                    <v-btn icon dark @click="closeMainDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <v-container fluid>
                        <v-data-table
                            :headers="headers"
                            :loading="$apollo.queries.tenantGrowthTasks.loading"
                            :items="tenantGrowthTasks.edges"
                            item-key="node.id"
                            disable-pagination
                            hide-default-footer
                            loading-text="Loading... Please wait"
                        >
                            <template
                                v-slot:item.departement="{
                                    item
                                }"
                            >
                                <span v-if="item.node.currentGrowthTaskPhase"
                                    >{{
                                        item.node.currentGrowthTaskPhase
                                            .greenhouseDepartmentSection
                                            .greenhouseDepartment.greenhouse
                                            .name
                                    }}
                                    -
                                    {{
                                        item.node.currentGrowthTaskPhase
                                            .greenhouseDepartmentSection
                                            .greenhouseDepartment.name
                                    }}
                                    -
                                    {{
                                        item.node.currentGrowthTaskPhase
                                            .greenhouseDepartmentSection.name
                                    }}</span
                                >
                            </template>
                            <template
                                v-slot:item.node.potSize.potSizeCm="{
                                    item
                                }"
                            >
                                <span
                                    >{{ item.node.potSize.potSizeCm }} cm</span
                                >
                            </template>
                            <template
                                v-slot:item.node.totalInventory="{
                                    item
                                }"
                            >
                                <span>{{ item.node.totalInventory }} </span>
                                <v-tooltip
                                    top
                                    v-if="item.node.lockedForCustomer"
                                >
                                    <template
                                        v-slot:activator="{
                                            on
                                        }"
                                    >
                                        <v-icon small color="error" v-on="on"
                                            >lock</v-icon
                                        >
                                    </template>
                                    <span>{{
                                        item.node.lockedForCustomer.name
                                    }}</span>
                                </v-tooltip>
                            </template>
                            <template
                                v-slot:item.node.salesStartDate="{
                                    item
                                }"
                            >
                                <v-chip
                                    small
                                    dark
                                    color="grey"
                                    v-if="item.node.totalInventory <= 0"
                                    >Closed</v-chip
                                >
                                <v-chip
                                    small
                                    color="error"
                                    dark
                                    v-else-if="
                                        item.node.isReadyToSell &&
                                            item.node.salesEndDate < today
                                    "
                                    >Sales ({{
                                        calculateDaysBetweenDays(
                                            today,
                                            item.node.salesEndDate
                                        ) - 1
                                    }}
                                    days over)</v-chip
                                >
                                <v-chip
                                    small
                                    color="orange"
                                    dark
                                    v-else-if="
                                        item.node.isReadyToSell &&
                                            item.node.salesStartDate <= today
                                    "
                                    >Sales ({{
                                        calculateDaysBetweenDays(
                                            item.node.salesEndDate,
                                            today
                                        ) + 1
                                    }}
                                    days left)</v-chip
                                >
                                <v-chip
                                    small
                                    color="blue"
                                    dark
                                    v-else-if="
                                        item.node.growthStartDate > today
                                    "
                                    >Planned ({{
                                        calculateDaysBetweenDays(
                                            item.node.growthStartDate,
                                            today
                                        )
                                    }}
                                    days left)</v-chip
                                >
                                <v-chip small color="success" dark v-else
                                    >Growing ({{
                                        calculateDaysBetweenDays(
                                            item.node.salesStartDate,
                                            today
                                        )
                                    }}
                                    days left)</v-chip
                                >
                            </template>

                            <template
                                v-slot:item.node.growthStartDate="{
                                    item
                                }"
                            >
                                <span>{{
                                    item.node.growthStartDate
                                        | moment("YYYY-MM-DD ([W]WW)")
                                }}</span>
                            </template>

                            <template
                                v-slot:item.node.actualGrowthDays="{
                                    item
                                }"
                            >
                                {{ item.node.actualGrowthDays }}
                                <v-chip
                                    v-if="
                                        item.node.actualGrowthDays != null &&
                                            plantGrowthTemplateObj
                                    "
                                    :color="
                                        Math.abs(
                                            item.node.actualGrowthDays -
                                                plantGrowthTemplateObj.totalGrowthDays
                                        ) < 3
                                            ? 'success'
                                            : Math.abs(
                                                  item.node.actualGrowthDays -
                                                      plantGrowthTemplateObj.totalGrowthDays
                                              ) < 8
                                            ? 'warning'
                                            : 'error'
                                    "
                                    dark
                                    small
                                    class="ml-2 mb-1"
                                >
                                    <span
                                        v-if="
                                            item.node.actualGrowthDays -
                                                plantGrowthTemplateObj.totalGrowthDays >
                                                0
                                        "
                                        >+</span
                                    >
                                    {{
                                        item.node.actualGrowthDays -
                                            plantGrowthTemplateObj.totalGrowthDays
                                    }}
                                </v-chip>
                            </template>

                            <template
                                v-slot:item.node.actualSalesDays="{
                                    item
                                }"
                            >
                                {{ item.node.actualSalesDays }}
                                <v-chip
                                    v-if="
                                        item.node.actualSalesDays != null &&
                                            plantGrowthTemplateObj
                                    "
                                    :color="
                                        Math.abs(
                                            item.node.actualSalesDays -
                                                plantGrowthTemplateObj.maxSalesDays
                                        ) < 3
                                            ? 'success'
                                            : Math.abs(
                                                  item.node.actualSalesDays -
                                                      plantGrowthTemplateObj.maxSalesDays
                                              ) < 8
                                            ? 'warning'
                                            : 'error'
                                    "
                                    dark
                                    small
                                    class="ml-2 mb-1"
                                >
                                    <span
                                        v-if="
                                            item.node.actualSalesDays -
                                                plantGrowthTemplateObj.maxSalesDays >
                                                0
                                        "
                                        >+</span
                                    >
                                    {{
                                        item.node.actualSalesDays -
                                            plantGrowthTemplateObj.maxSalesDays
                                    }}
                                </v-chip>
                            </template>

                            <template v-slot:item.action="{ item }">
                                <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="goToGrowthTaskDetail(item.node)"
                                        >View</v-btn>-->
                                <v-btn
                                    icon
                                    color="primary"
                                    @click="openGrowthTaskDialog(item.node)"
                                >
                                    <v-icon>remove_red_eye</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    color="primary"
                                    @click="goToGrowthTaskDetail(item.node.id)"
                                >
                                    <v-icon>launch</v-icon>
                                </v-btn>
                                <!-- <v-icon small @click="onDeletingTask(item.node)">delete</v-icon> -->
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import GrowthTaskDetailComponent from "@/components/growth/GrowthTaskDetailComponent.vue";
import moment from "moment";

export default {
    name: "plant-template-growth-task-score-list-dialog",
    props: ["dialog", "plantGrowthTemplateObj"],
    components: {
        GrowthTaskDetailComponent
    },

    apollo: {
        tenantGrowthTasks: {
            query: gql`
                query tenantGrowthTasks(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $totalInventory_Lte: Int
                    $plantGrowthTemplate_Id: ID
                    $actualGrowthDays_Gte: Int
                ) {
                    tenantGrowthTasks(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        orderBy: $orderBy
                        totalInventory_Lte: $totalInventory_Lte
                        plantGrowthTemplate_Id: $plantGrowthTemplate_Id
                        actualGrowthDays_Gte: $actualGrowthDays_Gte
                    ) {
                        edges {
                            node {
                                id
                                rawId
                                growthStartDate
                                growthEndDate
                                salesStartDate
                                salesEndDate
                                note
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                lockedForCustomer {
                                    id
                                    name
                                }
                                totalQuantity
                                actualGrowthDays
                                actualSalesDays
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 100,
                    plantGrowthTemplate_Id: this.plantGrowthTemplateObj.id,
                    actualGrowthDays_Gte: 0,
                    orderBy: "-growthStartDate"
                };
            },
            // Additional options here
            fetchPolicy: "network-only",
            update: data => data.tenantGrowthTasks,
            skip() {
                return !this.dialog;
            }
            // pollInterval: 300000 // ms 5min
        }
    },

    data() {
        return {
            deleteTaskDialog: false,
            growthTaskEditDialog: false,
            growthTaskDialog: false,
            isLoadingGrowthTasks: false,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,
            isExportingGrowthTasks: false,

            growthTaskActionsCount: 0,
            growthTaskReadyToSellOverdueCount: 0,
            shouldResetDataTablePage: false,
            tenantGrowthTasks: {},
            tenantPotSizes: {},

            selectedGrowthTaskNodeId: null,
            selectedGrowthTaskRawId: null,
            selectedPlanListPotSizeId: null,

            search: "",
            toggleGrowthTaskScope: 0,

            deletingGrowthTask: null,
            filteredGrowthTasks: [],
            greenhouseDepartments: [],
            selectedDepartments: [],
            // dates: [],
            // json_fields: {
            //     ID: "node.rawId",
            //     Greenhouse:
            //         "node.currentGrowthTaskPhase.greenhouseDepartmentSection.greenhouseDepartment.greenhouse.name",
            //     Section:
            //         "node.currentGrowthTaskPhase.greenhouseDepartmentSection.name",
            //     Department:
            //         "node.currentGrowthTaskPhase.greenhouseDepartmentSection.greenhouseDepartment.name",
            //     "Plant Species": "node.plant.plantSpecies.name",
            //     Plant: "node.plant.name",
            //     "Start Date": "node.growthStartDate",
            //     Note: "node.note",
            //     "Pot Size": "node.potSize.potSizeCm",
            //     Tag: "node.tag.tag",
            //     Inventory: "node.totalInventory"
            // },

            headers: [
                {
                    text: "ID",
                    value: "node.rawId",
                    sortable: true
                },
                // {
                //     text: "Department",
                //     value: "departement",
                //     sortable: true
                // },
                // {
                //     text: "Plant Species",
                //     value: "node.plant.plantSpecies.name",
                //     sortable: true
                // },
                // {
                //     text: "Plant",
                //     value: "node.plant.name",
                //     sortable: true
                // },
                {
                    text: "Start Date",
                    value: "node.growthStartDate",
                    sortable: true
                },
                {
                    text: "Note",
                    value: "node.note",
                    sortable: true
                },
                // {
                //     text: "Pot Size",
                //     value: "node.potSize.potSizeCm",
                //     sortable: true
                // },
                {
                    text: "Color",
                    align: "left",
                    value: "node.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.tag.tag",
                    sortable: true
                },
                {
                    text: "Quantity",
                    value: "node.totalQuantity",
                    sortable: true
                },
                {
                    text: "Actual Growth Days",
                    value: "node.actualGrowthDays",
                    sortable: false
                },
                {
                    text: "Actual Sales Days",
                    value: "node.actualSalesDays",
                    sortable: false
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        today() {
            var _now = new Date();
            return moment(_now).format("YYYY-MM-DD");
        }
    },
    watch: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        // get tab of last visit from local
        if (localStorage.getItem("toggleGrowthTaskScope") != null) {
            this.toggleGrowthTaskScope = parseInt(
                localStorage.getItem("toggleGrowthTaskScope")
            );
        } else {
            this.toggleGrowthTaskScope = 0;
        }
    },
    methods: {
        closeMainDialog() {
            this.$emit("update:dialog", false);
            this.$emit("update:plantGrowthTemplateObj", null);
        },

        calculateDaysBetweenDays(day1, day2) {
            return moment(day1).diff(moment(day2), "day");
        },

        openGrowthTaskDialog(growthTask) {
            this.selectedGrowthTaskNodeId = growthTask.id;
            this.selectedGrowthTaskRawId = growthTask.rawId;
            this.growthTaskDialog = true;
        },

        closeGrowthTaskDialog() {
            this.growthTaskDialog = false;
            this.selectedGrowthTaskNodeId = null;
            this.selectedGrowthTaskRawId = null;
            this.$apollo.queries.tenantGrowthTasks.refresh();
        },

        goToGrowthTaskDetail(growthTaskNodeId) {
            let routeData = this.$router.resolve({
                name: "growthtask-detail",
                params: { id: growthTaskNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        goToGrowthTaskSettings() {
            this.$router.push({
                name: "growth-task-settings"
            });
        }
    }
};
</script>
